export const SCENARIO_SESSION_ID_HEADER_KEY = "scenario-session-id";
